import * as ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "view/App";
import "./styles/global.scss";
import ErrorCatcher from "./view/components/ErrorCatcher";

const mountElement = document.getElementById("app");

ReactDOM.render(
    <ErrorCatcher>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </ErrorCatcher>,
    mountElement,
);
